import React from "react";
import group from "../assets/Group1.png";
import p1 from "../assets/p1.png";
import p2 from "../assets/p2.png";
import p3 from "../assets/p3.png";
import p4 from "../assets/p4.png";
import p5 from "../assets/p5.png";
import "../App.css"; // Make sure CSS is imported

const features = [
  {
    img: p1,
    title: "Fast & Hassle-Free Transactions",
    description: "No paperwork, no ATM card—just Aadhaar and fingerprint.",
  },
  {
    img: p2,
    title: "Secure Biometric Authentication",
    description: "Powered by NPCI and UIDAI to ensure the highest level of security.",
  },
  {
    img: p3,
    title: "Ideal for Rural & Semi-Urban Areas",
    description: "AEPSPay helps customers who may not have access to traditional banking or internet-based services.",
  },
  {
    img: p4,
    title: " 24/7 Availability ",
    description: "Convenient service hours to meet customer needs anytime.",
  },
  {
    img: p5,
    title: "Boost for Retailers & Business Owners",
    description: "Earn attractive commissions on every AEPSPay transaction while offering valuable financial services to your customers.",
  },
];

const Effortless = () => {
  return (
    <div className="container py-lg-5 py-3 responsives">
      <h2 className="text-center fw-bold mb-5">
        Why Choose Our AEPSPay <br />Service?
      </h2>

     
       <div className="row align-items-center justify-content-center ">
  {/* Image */}
  <div className="col-md-6 order-1 order-md-1 text-center">
    <img src={group} alt="Phone App UI" className="img-fluid mb-4 mb-md-0" />
  </div>

  {/* Features */}
  <div className="col-md-6 order-2 order-md-2 position-relative feature-wrapper">
    <div className="feature-line-wrapper">
      <div className="dashed-line" />

      {features.map((feature, idx) => (
        <div key={idx} className="feature-item">
          <div className="icon-circle">
            <img src={feature.img} alt={feature.title} />
          </div>

          <div className="feature-text">
            <h6 className="mb-1 fw-semibold">{feature.title}</h6>
            <p className="mb-0 text-muted">
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

    </div>
  );
};

export default Effortless;
